export const constructAdditivesDTO = (pointsList, groups, additives) => {
  const result = pointsList.map((point) => ({
    id: point.id,
    title: point.title || point.name || 'Point',
    groups: [],
  }));

  const pointsMap = new Map(result.map((p) => [p.id, p]));

  // Sort groups
  groups.sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0));

  groups.forEach((grp) => {
    const point = pointsMap.get(grp.pointId);
    if (point) {
      point.groups.push({
        ...grp,
        items: [],
      });
    }
  });

  additives.forEach((additive) => {
    const point = pointsMap.get(additive.pointId);
    if (point) {
      let group = null;
      if (additive.groupId) {
        group = point.groups.find((g) => g.id === additive.groupId);
      }

      if (group) {
        group.items.push(additive);
      } else {
        // Uncategorized / Ungrouped
        let ungrouped = point.groups.find((g) => g.id === null);
        if (!ungrouped) {
          ungrouped = {
            pointId: point.id,
            name: 'ДОБАВКИ БЕЗ ГРУППЫ',
            id: null,
            isVisible: true,
            sortNum: 10000999,
            items: [],
          };
          point.groups.push(ungrouped);
        }
        ungrouped.items.push(additive);
      }
    }
  });

  // Re-sort to place "Ungrouped" correctly
  result.forEach((point) => {
    point.groups.sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0));
  });

  return result;
};
